var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.94 8.75V19.5H3.56V8.75h3.38zM5.25 3.5c1.08 0 1.75.72 1.77 1.66 0 .92-.69 1.66-1.79 1.66h-.02c-1.06 0-1.75-.74-1.75-1.66 0-.94.71-1.66 1.79-1.66zM19.5 19.5h-3.38v-5.75c0-1.36-.49-2.29-1.71-2.29-.93 0-1.49.63-1.73 1.24-.09.22-.11.52-.11.83v5.97H9.19s.04-9.69 0-10.75h3.38v1.52c.45-.69 1.25-1.68 3.05-1.68 2.23 0 3.9 1.46 3.9 4.59v6.32z",
    fill: "#01152E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.21a4c1e0b6888a626f326b16cdf72c7b.svg";
export { ForwardRef as ReactComponent };